<div class="full-layout">
    <!-- Topbar App Download Nudge - positioned above everything -->
    <app-download-cards-app-topbar-mobile-nudge></app-download-cards-app-topbar-mobile-nudge>
    <app-top-nav></app-top-nav>
    <router-outlet></router-outlet>
</div>
